import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import store from '../core/store';
import { logoutSuccess } from '../core/store/auth/reducers';
import { useEffect } from 'react';

const Header = () => {
  const navigate = useNavigate();
  const admin = useSelector((state: any) => state.auth);

  const handleLogout = () => {
    store.dispatch({
      type: logoutSuccess,
    });
    navigate('/auth/login');
  };

  // For Sidebar Toggle
  useEffect(() => {
    const handleToggleClick = () => {
      const body = document.body;

      if (body.classList.contains('mini-sidebar')) {
        body.classList.remove('mini-sidebar');
        document.querySelectorAll('.subdrop + ul').forEach((ul) => {
          (ul as HTMLUListElement).style.display = 'block';
        });
      } else {
        body.classList.add('mini-sidebar');
        document.querySelectorAll('.subdrop + ul').forEach((ul) => {
          (ul as HTMLUListElement).style.display = 'none';
        });
      }

      setTimeout(() => {
        // Add code for any necessary redraw logic here
      }, 300);
    };

    const toggleBtn = document.getElementById('toggle_btn');

    if (toggleBtn) {
      toggleBtn.addEventListener('click', handleToggleClick);
    }

    return () => {
      if (toggleBtn) {
        toggleBtn.removeEventListener('click', handleToggleClick);
      }
    };
  }, []);

  // For Sidebar Hover
  useEffect(() => {
    const handleMouseOver = (e: any) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById('toggle_btn');
      const sidebar = document.querySelector('.sidebar');

      if (body.classList.contains('mini-sidebar') && toggleBtn && toggleBtn.offsetParent) {
        const targetIsSidebar = sidebar && sidebar.contains(e.target);

        if (targetIsSidebar) {
          body.classList.add('expand-menu');
          document.querySelectorAll('.subdrop + ul').forEach((ul) => {
            (ul as HTMLUListElement).style.display = 'block';
          });
        } else {
          body.classList.remove('expand-menu');
          document.querySelectorAll('.subdrop + ul').forEach((ul) => {
            (ul as HTMLUListElement).style.display = 'none';
          });
        }

        return false;
      }
    };

    document.addEventListener('mouseover', handleMouseOver);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);


  useEffect(() => {
    const handleMobileBtnClick = () => {
      const wrapper = document.getElementsByClassName('main-wrapper')[0]; // Replace with the actual ID of your wrapper element
      const sidebarOverlay = document.querySelector('.sidebar-overlay');
      const htmlElement = document.documentElement;

      if (wrapper && sidebarOverlay) {
        wrapper.classList.toggle('slide-nav');
        sidebarOverlay.classList.toggle('opened');
        htmlElement.classList.toggle('menu-opened');
      }

      return false;
    };

    const mobileBtn = document.getElementById('mobile_btn');

    if (mobileBtn) {
      mobileBtn.addEventListener('click', handleMobileBtnClick);
    }

    return () => {
      if (mobileBtn) {
        mobileBtn.removeEventListener('click', handleMobileBtnClick);
      }
    };
  }, []);

  return (
    <div className="header header-one">
      <Link
        to={'/dashboard'}
        className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo"
      >
        <img src="/assets/img/softcom-black.png" className="img-fluid logo2" alt="Logo" style={{
          width: '70px',
        }} />
      </Link>
      <div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
        <div className="logo-white">
          <Link to={'/dashboard'}>
            <img
              src="/assets/img/logo-full-white.png"
              className="img-fluid logo-blue"
              alt="Logo"
            />
          </Link>
          <Link to={'/dashboard'}>
            <img
              src="/assets/img/logo-small-white.png"
              className="img-fluid logo-small"
              alt="Logo"
            />
          </Link>
        </div>
        <div className="logo-color">
          <Link to={'/dashboard'}>
            <img
              src="/assets/img/softcom-black.png"
              className="img-fluid logo-blue"
              alt="Logo"
              style={{
                width: '70px',
              }}
            />
          </Link>
          <Link to={'/dashboard'}>
            <img
              src="/assets/img/softcom-black.png"
              className="img-fluid logo-small"
              alt="Logo"
              style={{
                width: '50px',
              }}
            />
          </Link>
        </div>
      </div>
      {/* Sidebar Toggle */}
      <a href="javascript:void(0);" id="toggle_btn">
    <span className="toggle-bars">
      <span className="bar-icons" />
      <span className="bar-icons" />
      <span className="bar-icons" />
      <span className="bar-icons" />
    </span>
      </a>
      {/* /Sidebar Toggle */}
      {/* Mobile Menu Toggle */}
      <a className="mobile_btn" id="mobile_btn">
        <i className="fas fa-bars" />
      </a>
      {/* /Mobile Menu Toggle */}
      {/* Header Menu */}
      <ul className="nav nav-tabs user-menu">
        {/* User Menu */}
        <li className="nav-item dropdown">
          <a
            href="javascript:void(0)"
            className="user-link  nav-link"
            data-bs-toggle="dropdown"
          >
        <span className="user-img">
          <img
            src={admin.profilePic !== null ? admin.profilePic : `https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${admin.name}&size=40&rounded=true`}
            alt="img"
            className="profilesidebar"
          />
          <span className="animate-circle" />
        </span>
            <span className="user-content">
          <span className="user-details">{admin.username}</span>
          <span className="user-name">{admin.name}</span>
        </span>
          </a>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilemenu">
              <div className="subscription-menu">
                <ul>
                  <li>
                    <Link className="dropdown-item" to={'/update-profile'}>
                      Profile Settings
                    </Link>
                  </li>
                  {
                      admin.isOwner && <li>
                        <Link className="dropdown-item" to={'/settings'}>
                          Settings
                        </Link>
                      </li>
                  }
                </ul>
              </div>
              <div className="subscription-logout">
                <ul>
                  <li className="pb-0">
                  <a className="dropdown-item" href="#" onClick={handleLogout}>
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        {/* /User Menu */}
      </ul>
      {/* /Header Menu */}
    </div>

  );
};

export default Header;
